import React from 'react'
import { Menu } from './components/Menu/Menu'
import { Formulario } from './components/Formulario/Formulario'
import { Listado } from './components/Listado/Listado'
import { Switch, Route, Router } from 'react-router-dom'
import history from './infrastructure/history'

export const App = () => {
  return (
    <div className="App">
      <Menu />
      <Router history={history}>
        <Switch>
          {process.env.REACT_APP_VERSION === 'local' && <Route exact path="/form" component={Formulario} />}
          {process.env.REACT_APP_VERSION === 'local' && <Route path="/form/:id" component={Formulario} />}

          <Route path="/" component={Listado} />
        </Switch>
      </Router>
    </div>
  )
}
